import React from 'react'
import './termsNConditions.scss'
export default function TermsNConditions() {
  return (
    <div className='terms' >
      <iframe className='frame' src={'terms_new.html'}></iframe>
    </div>
  )
}